import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserDetectionService {
  public isChrome(): boolean {
    const userAgent = window.navigator.userAgent;
    if (
      userAgent.includes('Chrome') &&
      userAgent.includes('Safari') &&
      !userAgent.includes('Edg') &&
      !userAgent.includes('Firefox')
    ) {
      return true;
    }

    return false;
  }
}
